import * as React from 'react';
import { Button } from 'antd';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { conferenceSlice } from 'logic/store/conference/conference.slice';
import { RoomResponse } from 'logic/api-models/api-models';

type props = {
  roomResponse?: RoomResponse,
  disabled?: boolean,
  text?: string
}

const CallButton: FC<props> = ({ roomResponse, disabled, text }) => {
  const dispatch = useDispatch();

  const handleJoinButtonClick = () => {
    dispatch(conferenceSlice.actions.joinCall(roomResponse?._id || '' ));
  };

  return <>
    <Button disabled={disabled} type={'primary'} size={'large'} onClick={() => handleJoinButtonClick()}>{text}</Button>
  </>;
};

CallButton.defaultProps = {
  disabled: false,
  text: 'Button',
};

export default CallButton;
